import { render } from "./RelatedProductsAndConsume.vue?vue&type=template&id=d00b932c"
import script from "./RelatedProductsAndConsume.vue?vue&type=script&lang=js"
export * from "./RelatedProductsAndConsume.vue?vue&type=script&lang=js"
script.render = render

export default script